import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ModalRedeemCouponPage } from './modal-redeem-coupon.page';

const routes: Routes = [
  {
    path: '',
    component: ModalRedeemCouponPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ModalRedeemCouponPageRoutingModule {}
